// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"fc61ff01","308":"784bac6e","538":"5cdb4027","802":"68435c60"}[chunkId] + ".chunk.js";
};